import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import * as moment from 'moment';

@Component({
  selector: 'app-app-schedular',
  templateUrl: './app-schedular.component.html',
  styleUrls: ['./app-schedular.component.scss']
})
export class AppSchedularComponent implements OnInit {
  constructor(private modalService: NgbModal, private router: Router,
    private config: ApiConfiguration, private http: ApiService,
    private toast: ToastClientService,) { }

  ticketData = [];

  name = "";
  description = "";
  hours = "";
  minutes = "";
  date = "";
  value = false;
  is_display: number = 2;
  day = "";
  month = "";
  year = "";

  ngOnInit() {
    this.getData();
  }
  apiDate(date) {
    let a = moment(date).format("YYYY-MM-DD")
    return a;
  }
  apiTime(data) {
    let time = moment(data).format("hh:mm")
    return time;
  }

  getData() {
    this.http.get(this.config.getSchedular)
      .subscribe((data: any) => {
        console.log("getData", data)
        this.ticketData = data.data;
        this.toast.Success("Success")
      })
  }
  showRegionModal(targetModal) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
    });
  }

  addTicket(targetModal) {
    this.name = "";
    this.description = ""
    this.hours = "";
    this.minutes = "";
    this.date = "";
    this.value = false;
    this.is_display = 2;
    this.day = "";
    this.month = "";
    this.year = "";
    this.showRegionModal(targetModal);
  }

  editModal(Modal, data) {

    console.log("now", data.now_flag);
    if (data.now_flag == 2) {
      this.showRegionModal(Modal);
      let apiHour = moment(data.datetime_flag).format("h")
      let apiMinute = moment(data.datetime_flag).format("mm")
      let api_date = moment(data.datetime_flag).format("DD MM YYYY")
      console.log(data)
      this.name = data.transformation_name;
      this.description = data.batch_description;
      this.hours = apiHour;
      this.minutes = apiMinute;
      this.date = api_date;
      this.value = false;
      this.is_display = 2;
      this.day = "";
      this.month = "";
      this.year = "";
    } else {
      this.showRegionModal(Modal);
      // let apiHour = moment(data.datetime_flag).format("h")
      // let apiMinute = moment(data.datetime_flag).format("mm")
      // let api_date = moment(data.datetime_flag).format("DD MM YYYY")
      console.log(data)
      this.name = data.transformation_name;
      this.description = data.batch_description;
      this.hours = "";
      this.minutes = "";
      this.date = "";
      this.value = false;
      this.is_display = 2;
      this.day = "";
      this.month = "";
      this.year = "";
    }

  }


  changeStatus(value) {
    if (value == true) {
      this.is_display = 1;

    }
    else {
      this.is_display = 2
    }
    console.log(value)
  }
  createTicketSubject() {
    if (this.name == "" || this.description == "") {
      this.toast.Error("Fields are required")
    }
    else if ((this.is_display == 2) && (this.date == "" || this.hours == "" || this.minutes == "")) {
      this.toast.Error("Fields are required")
      console.log(this.is_display);
    }
    else {
      if (this.is_display == 2) {
        this.day = moment(this.date).format("DD");
        this.month = moment(this.date).format("MM");
        this.year = moment(this.date).format("YYYY");
      } else {
        this.date = ""
        this.month = ""
        this.day = ""
        this.year = ""
        this.hours = ""
        this.minutes = ""
      }
      let payload = {
        program_id: 1,
        transformation_name: this.name,
        batch_description: this.description,
        batch_month: this.month,
        batch_year: this.year,
        batch_day: this.day,
        batch_hr: this.hours,
        batch_mins: this.minutes,
        now_flag: this.is_display,
      }
      console.log("payload", payload);
      this.http.post(this.config.sendSchedular, payload)
        .subscribe((data: any) => {
          console.log("postData", data)
          this.toast.Success("Success");
          this.modalService.dismissAll();
          this.getData()
        }, (err) => {
          console.log(err.message)
        })
    }
  }
  omit_special_char(event) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }
}
